module.exports = __webpack_public_path__ + "media/images/items/anim-3-66e687b5d1821a64b819ff6815f538a6.webp";